import {
  GET_USER_DEFINITIONS_BY_GUID,
  GET_USER_DEFINITIONS_BY_GUID_SUCCESS,
  GET_USER_DEFINITIONS_PASSWORD_SEND_MAIL,
  GET_USER_DEFINITIONS_PASSWORD_SEND_MAIL_SUCCESS,
  UPDATE_USER_DEFINITIONS_NEW_PASSWORD,
  UPDATE_USER_DEFINITIONS_NEW_PASSWORD_SUCCESS,
  USER_DEFINITIONS_NEW_PASSWORD_API_ERROR

} from "./actionTypes"


export const getUserDefinitionByGuid = record => ({
  type: GET_USER_DEFINITIONS_BY_GUID,
  payload: record
})

export const getUserDefinitionByGuidSuccess = record => ({
  type: GET_USER_DEFINITIONS_BY_GUID_SUCCESS,
  payload: record,
})


export const userDefinitionPasswordSendMail = record => ({
  type: GET_USER_DEFINITIONS_PASSWORD_SEND_MAIL,
  payload: record,
})

export const userDefinitionPasswordSendMailSuccess = record => ({
  type: GET_USER_DEFINITIONS_PASSWORD_SEND_MAIL_SUCCESS,
  payload: record,
})

export const updateUserDefinitionNewPassword = record => ({
  type: UPDATE_USER_DEFINITIONS_NEW_PASSWORD,
  payload: record,
})

export const updateUserDefinitionNewPasswordSuccess = record => ({
  type: UPDATE_USER_DEFINITIONS_NEW_PASSWORD_SUCCESS,
  payload: record,
})


export const userDefinitionNewPasswordApiError = error => ({
  type: USER_DEFINITIONS_NEW_PASSWORD_API_ERROR,
  payload: error,
})

